export const MedicalCase = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5 7H19C20.105 7 21 7.895 21 9V18C21 19.105 20.105 20 19 20H5C3.895 20 3 19.105 3 18V9C3 7.895 3.895 7 5 7Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.5 13.5H14.5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 11V16"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M16 7L15.379 4.515C15.156 3.625 14.356 3 13.438 3H10.561C9.643 3 8.843 3.625 8.621 4.515L8 7"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Medical case</div>
    </div>
  );
};

export const FireExtinguisher = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1245_85059)">
          <path
            d="M20.3219 5.01097L20.322 5.01084L14.6332 3.30459L13.4255 2.94235L14.5533 2.37846L17.3644 0.972897C17.3646 0.972814 17.3647 0.972732 17.3649 0.972649C17.4239 0.942766 17.4686 0.890732 17.4893 0.827925C17.5101 0.764943 17.505 0.696286 17.4752 0.637056C17.4454 0.577829 17.3932 0.532882 17.3302 0.512103C17.2672 0.491324 17.1986 0.496415 17.1394 0.526257L17.1379 0.526988L12.786 2.70199L12.6866 2.75168L12.5755 2.75456C10.7499 2.802 9.01499 3.56022 7.74013 4.86776C6.46535 6.17523 5.75129 7.92867 5.75 9.75473L20.3219 5.01097ZM20.3219 5.01097L20.333 5.014M20.3219 5.01097L20.333 5.014M20.333 5.014C20.3651 5.02284 20.3951 5.03801 20.4213 5.05863C20.4475 5.07924 20.4693 5.10487 20.4854 5.13403C20.5015 5.16319 20.5117 5.19527 20.5152 5.22839C20.5188 5.26153 20.5157 5.29503 20.5061 5.32694C20.4965 5.35886 20.4806 5.38853 20.4594 5.41421C20.4382 5.43991 20.4121 5.4611 20.3826 5.47655L20.6144 5.91956L20.3826 5.47655C20.353 5.492 20.3207 5.50139 20.2875 5.50417C20.2543 5.50696 20.2209 5.50307 20.1892 5.49275L20.1893 5.49262L20.178 5.48926L13.6437 3.52895L13 3.33584V4.00786V5.3138V5.73585L13.4161 5.8067C14.3477 5.96535 15.1932 6.44819 15.8033 7.1699C16.4132 7.89143 16.7485 8.80528 16.75 9.75005C16.75 9.75028 16.75 9.75052 16.75 9.75075L16.75 21.75C16.75 22.0153 16.6446 22.2696 16.4571 22.4572C16.2696 22.6447 16.0152 22.75 15.75 22.75H9.75C9.48478 22.75 9.23043 22.6447 9.04289 22.4572C8.85536 22.2696 8.75 22.0153 8.75 21.75V16.5V16H8.25H6.75H6.25M20.333 5.014L6.25 16M6.25 16V16.5M6.25 16V16.5M6.25 16.5V19.5C6.25 19.5663 6.22366 19.6299 6.17678 19.6768C6.12989 19.7237 6.0663 19.75 6 19.75C5.9337 19.75 5.87011 19.7237 5.82323 19.6768C5.77634 19.6299 5.75 19.5663 5.75 19.5V9.75489L6.25 16.5ZM6.25 15V15.5H6.75H8.25H8.75V15V9.75042C8.75141 8.80552 9.08673 7.89153 9.69673 7.1699C10.3068 6.44819 11.1523 5.96535 12.0839 5.8067L12.5 5.73585V5.3138V3.7988V3.2313L11.937 3.30278C10.3673 3.50208 8.92401 4.26656 7.87724 5.45315C6.83047 6.63974 6.25197 8.16711 6.25 9.74942V9.75005V15ZM15.75 22.25H16.25V21.75V16.5V16H15.75H9.75H9.25V16.5V21.75V22.25H9.75H15.75ZM15.75 15.5H16.25V15V9.75005C16.25 8.82179 15.8812 7.93155 15.2249 7.27517C14.5685 6.61879 13.6783 6.25005 12.75 6.25005C11.8217 6.25005 10.9315 6.61879 10.2751 7.27517C9.61875 7.93155 9.25 8.82179 9.25 9.75005V15V15.5H9.75H15.75Z"
            stroke="#323232"
          />
        </g>
        <defs>
          <clipPath id="clip0_1245_85059">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <div>Fire extinguisher</div>
    </div>
  );
};

export const TvStand = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 20V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 20V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="4"
          y="2"
          width="16"
          height="9"
          rx="1"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <rect
          x="2"
          y="14.5"
          width="20"
          height="5.5"
          rx="1"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Tv stand</div>
    </div>
  );
};

export const Alarm = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 3.96643V3.02129"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.0025 5.99756L18.9476 5.05242"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.9975 5.99756L5.05236 5.05242"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M20.9787 12H21.9239"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.05112 12H2.99625"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.0008 13.0004V15.0012"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.0021 18.0025V12.7544C16.9325 10.0605 14.694 7.93213 12 7.99833C9.30602 7.93213 7.06754 10.0605 6.99792 12.7544V18.0025"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M17.6479 18.0024H6.26132C5.82224 18.0024 5.43447 18.2887 5.30522 18.7084L4.99709 19.7088C4.90362 20.0122 4.95976 20.3421 5.14837 20.5975C5.33697 20.8529 5.63564 21.0037 5.95318 21.0037H18.0017C18.3264 21.0037 18.631 20.846 18.8185 20.5808C19.006 20.3157 19.0531 19.976 18.9449 19.6698L18.5911 18.6693C18.4498 18.2697 18.0718 18.0024 17.6479 18.0024Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Alarm</div>
    </div>
  );
};

export const CCTV = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.2015 8.70564L20.2023 8.70599C20.2623 8.73226 20.3165 8.7701 20.3618 8.81733C20.4071 8.86456 20.4427 8.92026 20.4665 8.98126C20.4903 9.04224 20.5018 9.10732 20.5004 9.17278C20.499 9.23822 20.4847 9.30275 20.4583 9.36267L20.458 9.36341L19.935 10.5574L19.7276 11.0308L20.2077 11.2224L21.2789 11.6499L19.6504 15.7212L18.4136 15.2267L17.9647 15.0473L17.7702 15.4899L17.4582 16.1999L17.4582 16.2C17.4052 16.3208 17.3066 16.4157 17.1839 16.4641C17.0612 16.5126 16.9244 16.5105 16.8032 16.4585L16.8029 16.4584L11.5979 14.2284L11.1271 14.0267L10.9368 14.5023L9.71478 17.5563L9.71443 17.5572C9.48626 18.1306 8.94155 18.5 8.323 18.5H4H3.5V19V21.5H2.5V14.5H3.5V17V17.5H4H8.323H8.66152L8.78724 17.1857L10.0272 14.0857L10.2085 13.6327L9.75998 13.4405L3.72205 10.8525C3.35666 10.6958 3.06835 10.4005 2.92041 10.0315C2.77252 9.66264 2.77696 9.25017 2.93275 8.88457C2.93281 8.88443 2.93286 8.88429 2.93292 8.88416L5.14252 3.73109C5.14253 3.73108 5.14253 3.73107 5.14254 3.73106C5.45843 2.99452 6.38706 2.62412 7.12654 2.94964C7.12655 2.94964 7.12655 2.94964 7.12655 2.94964L20.2015 8.70564ZM16.285 15.1496L16.7406 15.3448L16.9398 14.891L19.1408 9.87803L19.3416 9.42066L18.8845 9.2194L6.72246 3.8654L6.26033 3.66196L6.06143 4.12606L3.85343 9.27806L3.65646 9.73764L4.11605 9.93459L16.285 15.1496Z"
          stroke="#323232"
        />
      </svg>

      <div>CCTV</div>
    </div>
  );
};
